export const AUTH_COOKIE_NAME = 'intra_auth';

/**
 * Get every value stored under the auth cookie name.
 *
 * Several cookies can share that name when they were written on different domain
 * scopes: a cookie set on `staff.zol.fr` is also visible from
 * `staging.staff.zol.fr`. The browser exposes them sorted by ascending creation
 * date at equal path, so the last entry is the most recently written one.
 *
 * @returns {Array<string>}
 */
export function getIntraAuthCookies() {
  const prefix = `${AUTH_COOKIE_NAME}=`;

  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.startsWith(prefix))
    .map((cookie) => cookie.slice(prefix.length));
}

/**
 * Get the JWT from the auth cookie or undefined if not found.
 *
 * @returns {string|undefined}
 */
export function getIntraAuthCookie() {
  const cookies = getIntraAuthCookies();

  return cookies[cookies.length - 1];
}
